/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListTaskSubmissionVersionSummaryData } from './genericApiResponseListTaskSubmissionVersionSummaryData';
import type { GenericApiResponseListTaskSubmissionVersionSummaryMessage } from './genericApiResponseListTaskSubmissionVersionSummaryMessage';
import type { GenericApiResponseListTaskSubmissionVersionSummaryPagination } from './genericApiResponseListTaskSubmissionVersionSummaryPagination';
import type { GenericApiResponseListTaskSubmissionVersionSummaryError } from './genericApiResponseListTaskSubmissionVersionSummaryError';

export interface GenericApiResponseListTaskSubmissionVersionSummary {
  data?: GenericApiResponseListTaskSubmissionVersionSummaryData;
  message?: GenericApiResponseListTaskSubmissionVersionSummaryMessage;
  pagination?: GenericApiResponseListTaskSubmissionVersionSummaryPagination;
  error?: GenericApiResponseListTaskSubmissionVersionSummaryError;
  statusCode?: number;
}
